import styled, { css } from "styled-components";
import Dropdown from "ui/common/components/input/Dropdown/Dropdown";

export const UserMenuRoot = styled(Dropdown)(
    ({ theme }) => css`
        .SelectMenu.SelectMenu.SelectMenu {
            max-height: unset;
            background-color: ${theme.palette.gray[900]};
        }
        .SelectDisplay {
            min-width: 14rem;
            max-width: 20rem;
        }
    `,
);
